import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { InvoiceData } from 'src/app/_models/invoicedata';
import { AppService } from 'src/app/appservice.service';
import { TranslateService } from '@ngx-translate/core';
import { NewCustomerComponent } from '../new-customer/new-customer.component';

@Component({
  selector: 'app-list-customer',
  templateUrl: './list-customer.component.html',
  styleUrls: ['./list-customer.component.css']
})
export class ListCustomerComponent implements OnInit {

  displayedColumns: string[] = ['name', 'mobile', 'city', 'createdAt', 'id'];
  dataSource: MatTableDataSource<InvoiceData>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(public service: AppService, public translate: TranslateService, public dialog: MatDialog) {
    this.refreshList();
  }

  refreshList() {
    this.service.getRequest('api/customers').subscribe(x => {
      // Assign the data to the data source for the table to render
      this.dataSource = new MatTableDataSource(x);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
  ngOnInit() {
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openCustDialog(id: number): boolean {
    const dialogRef = this.dialog.open(NewCustomerComponent, {
      width: '600px',
      data: {
        id: id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log(result);
        this.refreshList();
      }
    });

    return false;
  }

  delete(id: number) {
    if (confirm(this.service.translate.instant('DeleteConfirm'))) {
      this.service.getRequest('api/customers/delete/' + id.toString()).subscribe(x => {
        if (x.Success) {
          this.service.sendMessage('DeleteSuccess');
        } else
          this.service.sendMessage('DeleteFailed');
        this.refreshList();
      }, error => {
        this.service.sendMessage('DeleteFailed');
        this.refreshList();
      });
    }
  }

}
